import { useMemo } from 'react';

import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import { Table } from '@tanstack/react-table';

import { useAppSelector } from 'src/app/store/hooks';
import { AssignmentRead } from 'src/common/external/bambi-api/bambiApi';

export function SelectAllHeader({ table }: { table: Table<AssignmentRead> }) {
  const driversSelected = useAppSelector(
    (state) => state.assignmentManagement.filterDrivers
  );
  const vehiclesSelected = useAppSelector(
    (state) => state.assignmentManagement.filterVehicles
  );
  const dateSelected = useAppSelector(
    (state) => state.assignmentManagement.dataGridSelectedRange
  );

  const disabled = useMemo(
    () => !driversSelected.length && !vehiclesSelected.length && !dateSelected,
    [driversSelected, vehiclesSelected, dateSelected]
  );

  return (
    <div data-testid="row-selection-column">
      {disabled ? (
        <SimpleTooltip
          trigger={
            <input
              className="cursor-not-allowed opacity-30"
              data-testid="select-all-rows-checkbox"
              type="checkbox"
              disabled
            />
          }
          content="You must filter by at least one driver, vehicle, or start date to select all rows"
        />
      ) : (
        <input
          data-testid="select-all-rows-checkbox"
          type="checkbox"
          checked={table.getIsAllRowsSelected()}
          onChange={() => table.toggleAllRowsSelected()}
        />
      )}
    </div>
  );
}
